<template>
  <div class="card" v-show="currentCardId == 'requests'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>本人希望欄を入力</h2>
        <p>給与・職種・勤務時間・勤務地などの希望を入力します（任意）</p>
      </div>
      <div class="add-item">
        <el-button type="success" @click="exampleVisible = true"
          >例文から追加</el-button
        >
      </div>
      <div class="card-content">
        <br />
        <NewRirekishoExampleSentenceDialog
          :value="exampleVisible"
          name="request-dialog"
          :items="requestExamples"
          :show-overwrite-warning="true"
          overwrite-warning="例文を選択すると、現在入力している文章は上書きされますのでご注意ください。"
          @input="exampleVisible = $event"
          @select="onSelectExample"
        />
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 15 }"
          placeholder="給与・職種・勤務時間・勤務地など希望があれば入力"
          v-model="formatData.request"
          v-proofread
        />
        <div class="attention-limit character" v-if="previewErrors.request">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
      <div
        class="card-header"
        v-if="getMode != 'production1'"
        style="text-align: center"
      >
        <p>あなたに興味をもった会社から直接オファーを受けることができます。</p>
      </div>
      <div
        class="card-content"
        v-if="getMode != 'production1'"
        style="text-align: center"
      >
        <div class="edit-form-item select-list">
          <li class="select-item">
            <p class="item-name">学部・学科</p>
            <label class="selectbox-3">
              <select
                v-model="formatData.department"
                placeholder="選択してください"
              >
                <option
                  v-for="item in departmentOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </li>
          <li class="select-item">
            <p class="item-name">希望勤務地</p>
            <label class="selectbox-3">
              <select
                v-model="formatData.hopeAreaPref"
                placeholder="選択してください"
              >
                <option v-for="item in prefOptions" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </label>
          </li>
          <li class="select-item">
            <p class="item-name">希望業界</p>
            <label class="selectbox-3">
              <select
                v-model="formatData.hopeIndustry"
                placeholder="選択してください"
              >
                <option
                  v-for="item in hopeIndustryOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </li>
          <li class="select-item">
            <p class="item-name">希望職種</p>
            <label class="selectbox-3">
              <select
                v-model="formatData.hopeJobcategory"
                placeholder="選択してください"
              >
                <option
                  v-for="item in hopeJobcategoryOptions"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </label>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import { PREF_OPTIONS } from '@/assets/lib/hope-options'
import departmentOptions from '@/utils/format-edit/departmentOptions.json'
import hopeIndustryOptions from '@/utils/format-edit/hopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentence,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'

const props = defineProps<{
  currentCardId?: string
  previewErrors: Record<string, string>
  exampleSentences?: NewRirekishoExampleSentences
}>()

const formatData = useNewRirekishoFormatData()
const exampleVisible = ref(false)
const prefOptions = PREF_OPTIONS
const getMode = computed(() => process.env.VUE_APP_MODE)

const requestExamples = computed(() => props.exampleSentences?.request || [])

function onSelectExample(item: NewRirekishoExampleSentence) {
  formatData.request +=
    item.description
      .replace(/<br>/gi, '\n')
      .replace('OOO', String(formatData.nowNensyu || ''))
      .replace('XXX', String(formatData.kibouNensyu || '')) + '\n'
}
</script>

<style lang="scss" scoped>
.select-list .selectbox-3 {
  display: inline-flex;
  align-items: center;
  position: relative;
}

.select-list .selectbox-3::after {
  position: absolute;
  right: 15px;
  width: 10px;
  height: 7px;
  background-color: #808286;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  content: '';
  pointer-events: none;
}

.select-list .selectbox-3 select {
  appearance: none;
  width: 500px;
  max-width: 100%;
  height: 2.8em;
  padding: 0.4em calc(0.8em + 30px) 0.4em 0.8em;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background-color: #fff;
  color: #606266;
  font-size: 1em;
  cursor: pointer;
}

.select-list {
  width: 500px;
  max-width: 100%;
  margin: 0 auto;
}

.select-list .select-item {
  margin-bottom: 20px;
}

@media screen and (width <= 640px) {
  .select-list .selectbox-3 select {
    width: 295px;
  }
}
</style>
